import { ClientToJsInterface } from '../clientToJsInterface';
import consoleLogger from '../../logger/consoleLogger';
import { getCommandHandler } from '../../webApp/getCommandHandler';
import { WebCommands } from '../../webApp/webCommands';

const logger = consoleLogger.getPrefixedCopy('EMSCRIPTEN_TO_JS');

type JsFromClientCommand = {
    method: WebCommands,
    params: string
};

export class EmscriptenClientJsInterface implements ClientToJsInterface {
    public expose(): void {
        logger.info('Exposing Emscripten client->js interface');
        window.app.webglInterface = function sendCommandToWebApp(rawCommand: string) {
            logger.info('ACCEPTED COMMAND RAW', rawCommand);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let handler: any;
            let command: JsFromClientCommand;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let params: { [key: string]: any };

            try {
                command = JSON.parse(rawCommand);
                params = command.params ? JSON.parse(command.params) : {};
                handler = getCommandHandler(command.method);
                handler.handle(params);
            } catch (error) {
                const methodName = command && command.method ? command.method : 'N/A';
                logger.error(`EmscriptenClientJsInterface error (${methodName})`, error);
                window.Sentry.captureException(error);
            }
        };
    }
}
